import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OrdersPage, SignatureModal } from './orders';
import { DirectivesModule } from '../../directives/directives.module';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    OrdersPage,
    SignatureModal
  ],
  imports: [
    IonicPageModule.forChild(OrdersPage),
    SignaturePadModule,
    DirectivesModule,
    PipesModule
  ],
  entryComponents: [
    SignatureModal
  ]
})
export class OrdersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/orders/orders.module.ts